import { connect } from 'react-redux';

import SearchResults from '../SearchResults';
import { clearSearchResults } from '../../../reducers/searchReducer';

import { TrackEvent_GA } from '../../../helpers/analytics';

// Redux generated Container Component
const mapStateToProps = (state, ownProps) => {

	const search = state.search;

	return {
		hasResult: search.hasResult,
		searchTerm: state.search.searchTerm,
		result: {
			gettingStarted: search.result.gettingStarted,
			api: search.result.api,
			javascriptSdk: process.env.DOCS_TYPE === 'internal' ? search.result.javascriptSdk : [],
			widgets: process.env.DOCS_TYPE === 'internal' ? search.result.widgets : [],
		}
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onClick: (e, result, term) => {
			if (result && term) {
				TrackEvent_GA(`Search Result Clicked | search: ${term} | result: ${result}`, 'Search');
			}
			dispatch(clearSearchResults());
		}
	};
};


// <SearchResults />
const SearchResultsContainer = connect(mapStateToProps, mapDispatchToProps)(SearchResults);

export default SearchResultsContainer;



// WEBPACK FOOTER //
// ./src/components/search/containers/SearchResultContainer.js